var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-app-modal", {
        attrs: {
          width: 700,
          fluid: _vm.serverLoading,
          "disable-submit": !_vm.unitInputValidator(_vm.units),
        },
        on: {
          "on-cancel-click": function ($event) {
            return _vm.$emit("close-modal")
          },
          "transition-ended": function ($event) {
            _vm.isModalReady = true
          },
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _vm.serverLoading || !_vm.isDataReady || !_vm.isModalReady
                  ? [
                      _c("loading-animation", {
                        attrs: {
                          "loading-title": _vm.$t(
                            "modal:edit_units.loading.units_modal_loading"
                          ),
                        },
                      }),
                    ]
                  : _vm.serverError
                  ? [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("modal:edit_units.feedback.error")) +
                          "\n      "
                      ),
                    ]
                  : _vm.serverSuccess
                  ? [
                      _vm.updateLoading
                        ? [
                            _c("loading-animation", {
                              attrs: {
                                "display-type": "blocking",
                                "loading-title": _vm.$t(
                                  "modal:edit_units.loading.units_modal_saving"
                                ),
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bs" },
                        [
                          _c("div", { staticClass: "mb-4" }, [
                            _c("h1", { staticClass: "mb-0" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("modal:edit_units.title_new", {
                                      unitName: _vm.$t(
                                        _vm.cloudUnitType.loco_key
                                      ),
                                    })
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-secondary" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("modal:edit_units.subtitle_new", {
                                      unitName: _vm.$t(
                                        _vm.cloudUnitType.loco_key
                                      ),
                                    })
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("base-number-input-element", {
                            attrs: {
                              title: _vm.$t(
                                "modal:edit_units.slot_input.title_new",
                                { unitName: _vm.$t(_vm.cloudUnitType.loco_key) }
                              ),
                              disabled: _vm.changesAllowed,
                              description: _vm.$t(
                                "modal:edit_units.slot_input.description_new",
                                { unitName: _vm.$t(_vm.cloudUnitType.loco_key) }
                              ),
                              locale:
                                _vm.customer != null
                                  ? _vm.customer.locale
                                  : null,
                              "valid-state": _vm.isUnitInputValid,
                            },
                            model: {
                              value: _vm.units,
                              callback: function ($$v) {
                                _vm.units = _vm._n($$v)
                              },
                              expression: "units",
                            },
                          }),
                          _vm._v(" "),
                          _vm.sliderMarker.length > 1
                            ? _c(
                                "div",
                                [
                                  _c("vue-smart-slider", {
                                    attrs: {
                                      disabled: _vm.changesAllowed,
                                      marker: _vm.sliderMarker,
                                      "prop-default-value": _vm.units,
                                      min: _vm.minUnits,
                                      max: _vm.maxUnits,
                                      width: 1000,
                                    },
                                    on: {
                                      "on-value-changed": function ($event) {
                                        _vm.units = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c("div", { staticClass: "d-flex justify-content-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-light btn-sm mx-2 px-4",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close-modal")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("general:confirm.cancel_btn_text")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-brand mx-2 btn-sm px-4",
                      attrs: { disabled: _vm.changesAllowed },
                      on: { click: _vm.onEditUnitsAccept },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("general:confirm.confirm_btn_text")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }